import { Navigate } from 'react-router';
import { FullPageLoading } from './require-session.js';
import { lastWorkspace, useMe } from './session.js';

/** "/" → last visited (or first) workspace, or the create-workspace screen when there is none. */
export function HomeRedirect() {
  const me = useMe();
  if (!me.data) return <FullPageLoading />;
  const target = lastWorkspace(me.data.memberships);
  if (!target) return <Navigate to="/espacios/nuevo" replace />;
  return <Navigate to={`/w/${target.workspaceId}/inicio`} replace />;
}

/** Validates a post-login `siguiente` target: same-origin relative paths only (no open redirects). */
export function safeNext(raw: string | null | undefined, fallback = '/'): string {
  if (!raw) return fallback;
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/\\')) return fallback;
  return raw;
}
